/* START-only UI: one existing purchase action, with a deferred official tutorial. */
(() => {
  function init(page) {
    if (page.dataset.mobileExperience === 'true') return;
    page.dataset.mobileExperience = 'true';
    const $ = selector => page.querySelector(selector);
    const dictionary = JSON.parse($('[data-ds-mobile-translations]')?.textContent || '{}');
    const originalDictionary = JSON.parse($('[data-ds-translations]')?.textContent || '{}');
    const copy = () => dictionary[page.lang] || dictionary.de || {};
    const purchase = $('[data-ds-checkout]');
    const sticky = $('[data-ds-sticky-buy]');
    const stickyButton = $('[data-ds-sticky-checkout]');
    const stickyPrice = $('[data-ds-sticky-price]');
    const mainPrice = $('[data-ds-price]');
    const mobile = matchMedia('(max-width: 749px)');
    let queued = false;
    let fromSticky = false;
    function syncSticky() {
      queued = false;
      if (!purchase || !sticky || !stickyButton || !mainPrice) return;
      stickyPrice.textContent = mainPrice.textContent;
      stickyButton.disabled = purchase.disabled;
      const regularLabel = originalDictionary[page.lang]?.checkout;
      stickyButton.textContent = purchase.textContent === regularLabel ? copy().sticky_buy : purchase.textContent;
      const editable = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
      const blocked = !($('[data-ds-lightbox]')?.hidden ?? true) || Boolean($('[data-ds-mobile-menu][open]')) ||
        Boolean($('.ds-market-trigger[aria-expanded="true"]')) || Boolean(document.querySelector('#shopify-pc__banner__btn-decline')?.getClientRects().length);
      const passedPurchase = purchase.getBoundingClientRect().bottom < 0;
      sticky.hidden = !mobile.matches || !passedPurchase || blocked || editable;
    }
    function scheduleSticky() { if (!queued) { queued = true; requestAnimationFrame(syncSticky); } }
    stickyButton?.addEventListener('click', () => {
      if (purchase?.disabled) return;
      fromSticky = true;
      purchase.click();
      syncSticky();
    });
    const observer = new MutationObserver(scheduleSticky);
    if (purchase) observer.observe(purchase, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
    if (mainPrice) observer.observe(mainPrice, { childList: true, characterData: true, subtree: true });
    observer.observe(page, { attributes: true, attributeFilter: ['lang'] });
    const lightbox = $('[data-ds-lightbox]');
    if (lightbox) observer.observe(lightbox, { attributes: true, attributeFilter: ['hidden'] });
    const error = $('[data-ds-checkout-error]');
    if (error) new MutationObserver(() => {
      if (fromSticky && !error.hidden && error.textContent) {
        fromSticky = false;
        error.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      scheduleSticky();
    }).observe(error, { attributes: true, attributeFilter: ['hidden'], childList: true });
    new IntersectionObserver(scheduleSticky, { threshold: [0, .2, 1] }).observe(purchase);
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky, { passive: true });
    window.visualViewport?.addEventListener('resize', scheduleSticky, { passive: true });
    document.addEventListener('focusin', scheduleSticky);
    document.addEventListener('focusout', scheduleSticky);
    document.addEventListener('click', scheduleSticky, { passive: true });
    document.addEventListener('visitorConsentCollected', scheduleSticky);
    const more = $('[data-ds-app-more]');
    if (more) {
      if (!mobile.matches) more.open = true;
      more.addEventListener('toggle', () => requestAnimationFrame(() => window.dispatchEvent(new Event('resize'))));
    }
    syncSticky();

    const video = $('[data-ds-video]');
    if (!video) return;
    const nativeVideo = $('[data-ds-native-video]');
    const poster = $('[data-ds-video-play]');
    const loading = $('[data-ds-video-loading]');
    const videoError = $('[data-ds-video-error]');
    const retry = $('[data-ds-video-retry]');
    const copyButton = $('[data-ds-video-copy]');
    const status = $('[data-ds-video-status]');
    const external = $('[data-ds-video-external]');
    nativeVideo?.classList.add('ds-video-native');
    copyButton?.classList.add('ds-video-copy');
    status?.classList.add('ds-video-status');
    external?.classList.add('ds-video-external');
    const rawSource = nativeVideo?.getAttribute('src')?.trim() || nativeVideo?.querySelector('source[src]')?.getAttribute('src')?.trim();
    const available = Boolean(nativeVideo && rawSource);
    let busy = false;
    let playbackTimer;
    let attempt = 0;
    let hasStarted = false;
    let videoVisible = true;
    const setVideoStarted = started => { video.dataset.videoStarted = String(started); };
    setVideoStarted(false);
    const showStatus = message => { if (status) status.textContent = message; };
    function stopLoading() {
      clearTimeout(playbackTimer);
      busy = false;
      if (loading) loading.hidden = true;
      if (poster) poster.disabled = !available;
    }
    function showUnavailable() {
      hasStarted = false;
      setVideoStarted(false);
      stopLoading();
      video.dataset.videoState = 'unavailable';
      if (poster) {
        poster.hidden = false;
        poster.disabled = true;
        poster.setAttribute('aria-disabled', 'true');
        poster.setAttribute('aria-label', copy().video_unavailable || '');
        poster.dataset.i18nLabel = 'video_unavailable';
        const label = poster.querySelector('.ds-video-poster-label');
        if (label) { label.textContent = copy().video_unavailable || ''; label.dataset.i18n = 'video_unavailable'; }
      }
      if (retry) retry.disabled = true;
      if (videoError) videoError.hidden = true;
      showStatus(copy().video_unavailable || '');
    }
    function failure() {
      attempt += 1;
      video.dataset.videoState = 'error';
      hasStarted = false;
      setVideoStarted(false);
      stopLoading();
      nativeVideo?.pause();
      if (nativeVideo) nativeVideo.controls = false;
      if (poster) poster.hidden = false;
      if (videoError) videoError.hidden = false;
    }
    function pausePlayback() {
      nativeVideo?.pause();
      if (busy) {
        attempt += 1;
        stopLoading();
        video.dataset.videoState = 'paused';
        if (!hasStarted && poster) { setVideoStarted(false); poster.hidden = false; nativeVideo.controls = false; }
      }
    }
    async function play(event) {
      if (!available) { showUnavailable(); return; }
      if (busy) return;
      const request = ++attempt;
      busy = true;
      if (poster) poster.disabled = true;
      if (videoError) videoError.hidden = true;
      if (loading) loading.hidden = false;
      video.dataset.videoState = 'loading';
      setVideoStarted(true);
      try {
        if (nativeVideo.error) nativeVideo.load();
        if (nativeVideo.ended) nativeVideo.currentTime = 0;
        nativeVideo.controls = true;
        playbackTimer = setTimeout(() => { if (request === attempt) failure(); }, 30000);
        await nativeVideo.play();
        if (request !== attempt) return;
        if (event?.detail === 0) nativeVideo.focus({ preventScroll: true });
      } catch (_error) { if (request === attempt) failure(); }
    }
    poster?.addEventListener('click', play);
    retry?.addEventListener('click', play);
    if (nativeVideo) {
      nativeVideo.preload = 'none';
      nativeVideo.controls = false;
      nativeVideo.addEventListener('playing', () => {
        hasStarted = true;
        setVideoStarted(true);
        stopLoading();
        if (poster) poster.hidden = true;
        if (videoError) videoError.hidden = true;
        nativeVideo.controls = true;
        video.dataset.videoState = 'playing';
        if (!videoVisible || document.hidden) pausePlayback();
      });
      nativeVideo.addEventListener('pause', () => {
        if (['error', 'unavailable', 'ended'].includes(video.dataset.videoState)) return;
        if (busy) attempt += 1;
        stopLoading();
        video.dataset.videoState = 'paused';
        if (!hasStarted && poster) { setVideoStarted(false); poster.hidden = false; nativeVideo.controls = false; }
      });
      nativeVideo.addEventListener('ended', () => {
        stopLoading();
        hasStarted = false;
        setVideoStarted(false);
        nativeVideo.controls = false;
        if (poster) poster.hidden = false;
        video.dataset.videoState = 'ended';
      });
      nativeVideo.addEventListener('error', () => { if (available) failure(); });
    }
    if (!available) showUnavailable();
    else {
      video.dataset.videoState = 'ready';
      if (poster) { poster.disabled = false; poster.removeAttribute('aria-disabled'); }
      new IntersectionObserver(entries => {
        videoVisible = entries[0].intersectionRatio >= .1;
        if (!videoVisible) pausePlayback();
      }, { threshold: [.1] }).observe(video);
      document.addEventListener('visibilitychange', () => { if (document.hidden) pausePlayback(); });
    }
    external?.addEventListener('click', pausePlayback);
    copyButton?.addEventListener('click', async () => {
      if (copyButton.getAttribute('aria-busy') === 'true') return;
      const id = video.dataset.videoId;
      const youtubeUrl = external?.href || (/^[A-Za-z0-9_-]{11}$/.test(id || '') ? `https://www.youtube.com/watch?v=${id}` : '');
      copyButton.setAttribute('aria-busy', 'true');
      copyButton.disabled = true;
      try {
        if (!youtubeUrl || !navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(youtubeUrl);
        showStatus(copy().video_copied || '');
      } catch (_error) {
        showStatus(copy().video_copy_failed || '');
        if (status && youtubeUrl) {
          const field = document.createElement('input');
          field.type = 'text';
          field.readOnly = true;
          field.value = youtubeUrl;
          field.className = 'ds-video-copy-url';
          field.setAttribute('aria-label', copy().video_copy || 'YouTube');
          status.append(field);
          field.focus({ preventScroll: true });
          field.select();
        }
      } finally {
        copyButton.disabled = false;
        copyButton.removeAttribute('aria-busy');
      }
    });
  }
  function boot() { document.querySelectorAll('[data-ds-page]').forEach(init); }
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
